import Vue from 'vue';

export default {
  // 确定 延长公告
  extendAnnouncement(params) {
    return Vue.axios.post('api/v1.0/chanquan/center/extendAnnouncement', params);
  },
  // 延长公告申请记录
  getExtendHistory (params) {
    return Vue.axios.post(`api/v1.0/chanquan/center/extendAnnouncementRecords?projectId=${params.projectId}&type=${params.type}`);
  }
};
